import React from "react";
import { MenuIcon, PanelsTopLeft } from "lucide-react";

import { Button } from "../ui/button";
import LogoIcon from "../../assets/Frame 2.svg";
import { Menu } from "./menu";
import { Sheet, SheetContent, SheetHeader, SheetTrigger } from "../ui/sheet";

export function SheetMenu() {
  return (
    <Sheet>
      <SheetTrigger className="lg:hidden" asChild>
        <Button
          className="h-8 bg-lightGray border-lightGray"
          variant="outline"
          size="icon"
        >
          <MenuIcon size={20} className="text-white" />
        </Button>
      </SheetTrigger>
      <SheetContent
        className="sm:w-72 px-3 h-full flex flex-col bg-sidebar"
        side="left"
      >
        <SheetHeader>
          <Button
            className="flex justify-center items-center pb-2 pt-1"
            variant="link"
            asChild
          >
            <a href="/dashboard" className="flex items-center gap-2">
              <div className="rounded-full overflow-hidden w-10 h-10">
                <img src={LogoIcon} alt="logo" />
              </div>
              <div className="text-primary text-lg">GuideproAI</div>
            </a>
          </Button>
        </SheetHeader>
        <Menu isOpen />
      </SheetContent>
    </Sheet>
  );
}
